'use strict';
import Accordion from './accordion';

export class WebFormRequest {
    init (fromModal = false) {
        if (!fromModal && $('.page').data('action') !== 'Newsletter-Contact') {
            return;
        }

        this.form = fromModal ? $('.web-form-request-modal') : $('.web-form-request-page');
        this.stepOne = $('.contact-form-step-one', this.form);
        this.stepTwo = $('.contact-form-step-two', this.form);
        this.responseSuccess = $('.contact-form-success', this.form);
        this.responseError = $('.contact-form-error', this.form);
        this.observeSelection();
        this.observeFormSubmit();
    }

    observeSelection () {
        var _self = this;

        this.form.find('.contactType').chosen({
            disable_search: true
        });

        // Case Type selection
        this.form.on('change', '.contactType', function (_e) {
            var value = $(this).val();

            if (value === '') {
                $('.contactSubType', _self.form).addClass('hidden');
                return;
            }

            $('.contact-form-next-step', _self.form).prop('disabled', true);
            // Load SubTypes
            var question = $('option:selected', this).data('value');
            var url = $(this).data('url') + '?question=' + encodeURIComponent(question);
            var defaultLabel = $(this).data('default-label');
            $.spinner().start();
            $('.pre-contact-section', _self.form).html('');
            $.ajax({
                url: url,
                type: 'GET',
                success: function (data) {
                    $.spinner().stop();

                    // Empty select and fill with default label
                    const $select = $('.contactSubType', _self.form);
                    $select.empty().append($('<option>', {
                        value: '',
                        text: defaultLabel,
                        disabled: true,
                        selected: true
                    })).closest('.section-hidden').removeClass('visibility-hidden');

                    // Fill with subcategories list
                    if ('subcategories' in data && data.subcategories) {
                        data.subcategories.forEach(option => {
                            $select.append($('<option>', {
                                value: option.id,
                                text: option.label,
                                'data-value': option.value
                            }));
                        });
                    }

                    if (!$select.data('chosen')) {
                        $select.chosen({
                            disable_search: true
                        });
                    } else {
                        $select.val('').trigger('chosen:updated');
                    }

                    // Fill recap
                    var selectedType = $('.contactType option:selected', _self.form).text();
                    $('.contact-form-recap-type', _self.form).text(selectedType);
                },
                error: function (err) {
                    $.spinner().stop();
                    console.log(err);
                }
            });
        });

        // Case SubType selection
        this.form.on('change', '.contactSubType', function (_e) {
            var option = $('option:selected', this);
            $('.contact-form-recap-subtype', _self.form).text(option.text());
            $('.contact-form-next-step', _self.form).prop('disabled', option.is(':disabled'));
            const type = _self.getSelectedType();
            const subtype = _self.getSelectedSubtype();
            var url = $(this).data('url') + '?type=' + encodeURIComponent(type) + '&subtype=' + encodeURIComponent(subtype);
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'GET',
                success: function (data) {
                    $.spinner().stop();
                    $('.pre-contact-section', _self.form).html(data);
                    Accordion.setup(_self.form.find('.faqs .accordion'));
                },
                error: function (err) {
                    $.spinner().stop();
                    console.log(err);
                }
            });
        });

        // CTA "Proceed"
        this.form.on('click', '.contact-form-next-step', function (_e) {
            _self.stepOne.addClass('hidden');
            _self.stepTwo.removeClass('hidden');
            if (!Foundation.MediaQuery.atLeast('medium')) {
                $('.hide-step-two-mobile').addClass('hidden');
            }
            $('footer.simple-footer').addClass('fix-position-mobile');
        });

        // Edit selection
        this.form.on('click', '.edit-selection', function (_e) {
            _self.stepOne.removeClass('hidden');
            _self.stepTwo.addClass('hidden');
            if (!Foundation.MediaQuery.atLeast('medium')) {
                $('.hide-step-two-mobile').removeClass('hidden');
            }
        });
    }

    observeFormSubmit () {
        var _self = this;

        $('body').on('submit', 'form#form-contact', function (e) {
            e.preventDefault();

            let errors = [];
            $('#form-contact :input:not(:button)').each(function () {
                let validator = $(this).parsley();
                validator.validate();
                if (!validator.isValid()) {
                    errors.push(validator);
                }
            });
            if (errors.length > 0) {
                return;
            }

            const $form = $(this);
            var url = $form.attr('action');

            var captcha;
            if (document.querySelector('#g-recaptcha-response') != null) {
                captcha = document.querySelector('#g-recaptcha-response').value;
            }
            if (!captcha) {
                $('.no-robot', $form).removeClass('hidden');
                return;
            }

            var data = {
                contactName: $('[name="contactName"]', $form).val(),
                contactLastName: $('[name="contactLastName"]', $form).val(),
                contactEmail: $('[name="contactEmail"]', $form).val(),
                contactQuestion: $('[name="contactQuestion"]', $form).val(),
                contacDespription: $('[name="contacDespription"]', $form).val(),
                country: $('[name="country"]', $form).val(),
                contactType: $('[name="contactType"]', $form).val(),
                contactSubType: $('[name="contactSubType"]', $form).val(),
                contacOrder: $('[name="contacOrder"]', $form).val(),
                captcha: captcha || '',
                caseOrigin: findCaseOrigin()
            };

            $.spinner().start();
            $.ajax({
                url: url,
                type: 'POST',
                dataType: 'json',
                data: data,
                success: function (data) {
                    $.spinner().stop();
                    _self.stepTwo.addClass('hidden');

                    if (data.success) {
                        _self.responseSuccess.removeClass('hidden');
                        $('body').trigger('formContactSubmit');
                    } else {
                        _self.responseError.removeClass('hidden');
                    }
                    $('.hide-form').hide();
                    $('.form-request-title', _self.form).addClass('hidden');
                    $('.web-form-request-modal .tingle-modal-box').addClass('min-height-unset');
                    $('.web-form-request-modal .tingle-modal-box').addClass('height-unset');
                    $('footer.simple-footer').removeClass('fix-position-mobile');
                    $('.contact-form', _self.form).addClass('hide');
                    if ($('.web-form-request-modal').length === 0) {
                        $(window).scrollTop(0);
                    }
                },
                error: function (err) {
                    $.spinner().stop();
                    console.error(err);
                }
            });
        });
    }

    getSelectedType () {
        return this.form.find('.contactType :selected', this).data('value');
    }

    getSelectedSubtype () {
        return this.form.find('.contactSubType :selected', this).data('value');
    }
}

function findCaseOrigin () {
    try {
        let userAgent = window.navigator.userAgent.toLowerCase();
        let ios = /iphone|ipod|ipad/.test(userAgent);
        let android = /android/.test(userAgent);

        if (ios) {
            let isFromApp = window.location.href.toLowerCase().includes('caseorigin=app');
            if (isFromApp) {
                window.sessionStorage.setItem('caseorigin', 'app');
            } else {
                isFromApp = window.sessionStorage.getItem('caseorigin') === 'app';
            }
            return isFromApp ? 'Web Mobile App' : 'Web Mobile';
        } if (android) {
            let androidVersion = parseFloat(userAgent.slice(userAgent.indexOf('android') + 8));
            let isWebView = androidVersion >= 10 ? userAgent.includes('wv') : userAgent.includes('version/');
            return isWebView ? 'Web Mobile App' : 'Web Mobile';
        }
        return 'Web Desktop';
    } catch (e) {
        return 'Web Desktop';
    }
}

const webFormRequest = new WebFormRequest();
export default webFormRequest;
